/* FK predictive search: live product dropdown under the header search bar.
   Markup lives in sections/fk-header.liquid ([data-fkps]); results HTML comes
   from sections/fk-predictive-search.liquid via Shopify's predictive search API. */
(function () {
  'use strict';

  var FIELDS = 'title,product_type,variants.title,tag,vendor';
  var MIN_CHARS = 2;
  var DELAY = 200;

  function init(root) {
    if (!root || root.getAttribute('data-fkps-ready')) return;
    var input = root.querySelector('[data-fkps-input]');
    var box = root.querySelector('[data-fkps-box]');
    var res = root.querySelector('[data-fkps-results]');
    var live = root.querySelector('[data-fkps-live]');
    if (!input || !box || !res) return;
    root.setAttribute('data-fkps-ready', '1');

    var url = root.getAttribute('data-url') || '/search/suggest';
    var section = root.getAttribute('data-section') || 'fk-predictive-search';
    var cache = {};
    var timer = null;
    var ctrl = null;
    var active = -1;
    var current = '';

    function options() {
      return Array.prototype.slice.call(res.querySelectorAll('[role="option"]'));
    }

    function setActive(i) {
      var opts = options();
      if (!opts.length) { active = -1; input.removeAttribute('aria-activedescendant'); return; }
      if (i < 0) i = -1;
      if (i >= opts.length) i = opts.length - 1;
      active = i;
      opts.forEach(function (o, j) {
        var on = j === i;
        o.setAttribute('aria-selected', on ? 'true' : 'false');
        o.classList.toggle('is-active', on);
      });
      if (i >= 0) {
        input.setAttribute('aria-activedescendant', opts[i].id);
        var o = opts[i], top = o.offsetTop, bottom = top + o.offsetHeight;
        if (top < box.scrollTop) box.scrollTop = top;
        else if (bottom > box.scrollTop + box.clientHeight) box.scrollTop = bottom - box.clientHeight;
      } else {
        input.removeAttribute('aria-activedescendant');
      }
    }

    function open() {
      box.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function close() {
      box.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      setActive(-1);
    }

    function reset() {
      if (ctrl) { try { ctrl.abort(); } catch (e) {} ctrl = null; }
      clearTimeout(timer);
      current = '';
      root.classList.remove('is-loading');
      res.innerHTML = '';
      if (live) live.textContent = '';
      close();
    }

    function render(html, q) {
      if (q !== current) return;
      root.classList.remove('is-loading');
      res.innerHTML = html;
      var base = input.id || 'fkps';
      options().forEach(function (o, j) { o.id = base + '-opt-' + j; });
      var list = res.querySelector('[role="listbox"]');
      if (list) {
        list.id = base + '-listbox';
        input.setAttribute('aria-controls', list.id);
      } else {
        input.setAttribute('aria-controls', box.id);
      }
      var countEl = res.querySelector('[data-fkps-count]');
      var n = countEl ? parseInt(countEl.getAttribute('data-fkps-count'), 10) || 0 : 0;
      if (live) live.textContent = n ? (n + (n === 1 ? ' product' : ' products') + ' found') : 'No products found';
      active = -1;
      input.removeAttribute('aria-activedescendant');
      box.scrollTop = 0;
      open();
    }

    function showLoading() {
      root.classList.add('is-loading');
      if (!res.querySelector('[role="listbox"]') && !res.querySelector('.fkps__empty')) {
        res.innerHTML = '<p class="fkps__state">Searching&hellip;</p>';
      }
      open();
    }

    function fetchResults(q) {
      var key = q.toLowerCase();
      current = q;
      if (cache[key] !== undefined) { render(cache[key], q); return; }
      if (ctrl) { try { ctrl.abort(); } catch (e) {} }
      ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      showLoading();
      var src = url + '?q=' + encodeURIComponent(q) +
        '&' + encodeURIComponent('resources[type]') + '=product' +
        '&' + encodeURIComponent('resources[limit]') + '=8' +
        '&' + encodeURIComponent('resources[options][unavailable_products]') + '=last' +
        '&' + encodeURIComponent('resources[options][fields]') + '=' + encodeURIComponent(FIELDS) +
        '&section_id=' + encodeURIComponent(section);
      fetch(src, ctrl ? { signal: ctrl.signal, credentials: 'same-origin' } : { credentials: 'same-origin' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then(function (text) {
          var doc = new DOMParser().parseFromString(text, 'text/html');
          var wrap = doc.getElementById('shopify-section-' + section);
          var html = (wrap || doc.body).innerHTML;
          cache[key] = html;
          render(html, q);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (q !== current) return;
          root.classList.remove('is-loading');
          res.innerHTML = '<p class="fkps__state">Search is unavailable right now. Press Enter to see all results.</p>';
          open();
        });
    }

    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', box.id);

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < MIN_CHARS) { reset(); return; }
      timer = setTimeout(function () { fetchResults(q); }, DELAY);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim().length >= MIN_CHARS && res.innerHTML.trim() !== '') open();
    });

    input.addEventListener('keydown', function (e) {
      var opts = options();
      if (e.key === 'ArrowDown' || e.key === 'Down') {
        if (box.hidden && res.innerHTML.trim() !== '') { open(); }
        if (!opts.length) return;
        e.preventDefault();
        setActive(active + 1 >= opts.length ? 0 : active + 1);
      } else if (e.key === 'ArrowUp' || e.key === 'Up') {
        if (!opts.length) return;
        e.preventDefault();
        setActive(active <= 0 ? opts.length - 1 : active - 1);
      } else if (e.key === 'Enter') {
        if (!box.hidden && active >= 0 && opts[active]) {
          var a = opts[active].querySelector('a[href]');
          if (a) { e.preventDefault(); window.location.href = a.href; }
        }
      } else if (e.key === 'Escape' || e.key === 'Esc') {
        if (!box.hidden) {
          /* first Esc closes the dropdown only; the header's own Esc handler closes the bar */
          e.preventDefault();
          e.stopPropagation();
          close();
        }
      }
    });

    box.addEventListener('mousemove', function (e) {
      var o = e.target.closest ? e.target.closest('[role="option"]') : null;
      if (!o) return;
      var i = options().indexOf(o);
      if (i !== active) setActive(i);
    });

    /* keep focus in the input when clicking inside the dropdown (links still navigate) */
    box.addEventListener('mousedown', function (e) {
      if (e.target.closest && e.target.closest('a[href]')) return;
      e.preventDefault();
    });

    document.addEventListener('click', function (e) {
      if (!box.hidden && !root.contains(e.target)) close();
    });
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fkps]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
